import useTranslate from '~/common/utils/translate';
import React from 'react';

type OptionProps = React.DetailedHTMLProps<
  React.OptionHTMLAttributes<HTMLOptionElement>,
  HTMLOptionElement
>;

export const Option: React.FC<OptionProps> = ({ children, ...props }) => {
  const translate = useTranslate();
  return <option {...props}>{translate(children)}</option>;
};
